/**
 * PlaceGem use case: move a gem from inventory into a tower slot.
 */

import { placeGemInTower } from "../../domain/session.js";
import type { PlaceGemError } from "../../domain/types.js";
import type { RenderPort, AudioPort } from "../ports.js";
import { sessionToView } from "../state-view.js";

export interface PlaceGemDeps {
  render: RenderPort;
  audio: AudioPort;
  getSession(): import("../../domain/session.js").GameSession | null;
}

export function createPlaceGem(deps: PlaceGemDeps) {
  return function placeGem(
    gemId: string,
    towerId: string,
    slotIndex: number
  ): { ok: true } | PlaceGemError {
    const session = deps.getSession();
    if (!session) return { code: "InvalidSlot" };
    const ok = placeGemInTower(session, gemId, towerId, slotIndex);
    if (!ok) return { code: "InvalidSlot" };
    deps.render.update(sessionToView(session, "game"));
    deps.audio.play("click");
    return { ok: true };
  };
}
